
export function addSidebarNoticeButton(sidebar, buttonId, title, icon, callback, cls) {
    try {
        if (sidebar._getTab(buttonId))
            return;
    } catch (e) {

    }

    sidebar.addPanel({
        id: buttonId,
        tab: `<i class="fa fa-${icon}"></i>`,
        button: function (event) {
            callback(event);
        },
        title: title,
        class: 'blink_me' + (cls ? (' ' + cls) : "")
    });

    synchronizeSidebarAnimation(sidebar)
}

function removeSidebarNoticeButton(sidebar, buttonId) {
    sidebar.removePanel(buttonId);
}

function synchronizeSidebarAnimation(sidebar) {
    //iterating over all the notice buttons to synchronise their animation
    sidebar._tabitems.forEach(function (el) {
        if (el.classList.contains('blink_me'))
            resetAnimation(el);
    })
}

//restart an animation of element
function resetAnimation(el) {
    el.style.animation = 'none';
    // unsupported in Firefox?
    // el.offsetHeight = el.offsetHeight; /* some trick, trigger reflow */
    el.style.animation = null;
}
